<template>
  <div class="todo-item" :class="{ 'unread': !todo.read }">
    <div class="todo-icon">
      <i class="el-icon-time todo-icon-pending"></i>
    </div>
    
    <div class="todo-content">
      <div class="todo-title">
        {{ todo.title }}
        <el-tag v-if="!todo.read" type="danger" size="mini">未读</el-tag>
      </div>
      <div class="todo-description">{{ todo.content }}</div>
      <div v-if="todo.businessData" class="todo-business-data">
        <div class="business-item">
          <span class="business-label">知识名称:</span>
          <span class="business-value">{{ todo.businessData.knowledgeName }}</span>
        </div>
        <div class="business-item">
          <span class="business-label">操作人:</span>
          <span class="business-value">{{ todo.businessData.operatorName }}</span>
        </div>
      </div>
      <div class="todo-meta">
        <span class="todo-time">{{ formatTime(todo.createTime) }}</span>
        <span class="todo-priority" :class="getPriorityClass(todo.priority)">
          {{ getPriorityText(todo.priority) }}
        </span>
      </div>
    </div>
    
    <div class="todo-actions">
      <el-button 
        type="primary" 
        size="mini"
        @click="handleApprove"
        v-if="todo.requiresApproval"
      >
        审批
      </el-button>
      <el-button 
        type="success" 
        size="mini"
        @click="handleComplete"
      >
        完成
      </el-button>
      <el-button 
        type="info" 
        size="mini"
        @click="handleView"
      >
        查看
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TodoItem',
  props: {
    todo: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleApprove() {
      this.$emit('handle-todo', {
        todoId: this.todo.id,
        action: 'approve',
        data: {}
      })
    },
    
    handleComplete() {
      this.$emit('handle-todo', {
        todoId: this.todo.id,
        action: 'complete',
        data: {}
      })
    },
    
    handleView() {
      this.$emit('handle-todo', {
        todoId: this.todo.id,
        action: 'view',
        data: {}
      })
    },
    
    getPriorityClass(priority) {
      const classMap = {
        'HIGH': 'priority-high',
        'MEDIUM': 'priority-medium',
        'LOW': 'priority-low'
      }
      return classMap[priority] || 'priority-medium'
    },
    
    getPriorityText(priority) {
      const textMap = {
        'HIGH': '高优先级',
        'MEDIUM': '中优先级',
        'LOW': '低优先级'
      }
      return textMap[priority] || '中优先级'
    },
    
    formatTime(time) {
      if (!time) return ''
      const now = new Date()
      const todoTime = new Date(time)
      const diff = now - todoTime
      
      if (diff < 60000) {
        return '刚刚'
      } else if (diff < 3600000) {
        return Math.floor(diff / 60000) + '分钟前'
      } else if (diff < 86400000) {
        return Math.floor(diff / 3600000) + '小时前'
      } else {
        return todoTime.toLocaleDateString()
      }
    }
  }
}
</script>

<style scoped>
.todo-item {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid #F5F7FA;
  transition: background-color 0.3s;
  position: relative;
  min-height: 110px;
  background: #fff;
  box-shadow: 0 0 9px 0 rgba(29, 55, 129, .14);
  border-radius: 5px;
  width: 90%;
  margin: 10px 0;
}

.todo-item:hover {
  border: 1px solid #366AFF;
}

.todo-item.unread {
  border-left: 3px solid #366AFF;
  box-shadow: -2px 0 8px rgba(54, 106, 255, 0.15);
}

.todo-icon {
  margin-right: 12px;
  margin-top: 2px;
  width: 20px;
  text-align: center;
}

.todo-icon-pending {
  color: #E6A23C;
  font-size: 16px;
}

.todo-content {
  flex: 1;
  min-width: 0;
}

.todo-title {
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
  font-size: 14px;
}

.todo-description {
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 8px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.todo-business-data {
  margin: 8px 0;
  padding: 8px;
  background-color: #F8F9FA;
  border-radius: 4px;
  font-size: 12px;
}

.business-item {
  display: flex;
  margin-bottom: 4px;
}

.business-item:last-child {
  margin-bottom: 0;
}

.business-label {
  color: #909399;
  margin-right: 8px;
  min-width: 60px;
}

.business-value {
  color: #606266;
  font-weight: 500;
}

.todo-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #909399;
}

.priority-high {
  color: #F56C6C;
  font-weight: 500;
}

.priority-medium {
  color: #E6A23C;
  font-weight: 500;
}

.priority-low {
  color: #67C23A;
  font-weight: 500;
}

.todo-actions {
  margin-left: 8px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.3s;
}

.todo-item:hover .todo-actions {
  opacity: 1;
}

.todo-actions .el-button {
  padding: 4px 8px;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .todo-item {
    padding: 8px 12px;
  }
  
  .todo-actions {
    opacity: 1;
    flex-direction: column;
    gap: 2px;
  }
  
  .todo-actions .el-button {
    padding: 2px 6px;
    font-size: 11px;
  }
  
  .todo-description {
    -webkit-line-clamp: 1;
  }
}
</style>
